import { Client } from "./_clientService";

async function create(params: any) {
  const resp = await new Client({
    path: "/storeItem/create",
    payload: { ...params },
  }).post();

  return resp;
}

async function update(params: any) {
  const resp = await new Client({
    path: "/storeItem/update",
    payload: { ...params },
  }).post();

  return resp;
}

async function getStore(params: any) {
  let payload = {
    pageNo: params?.pageNo,
    limit: params?.pageSize,
    sortDirection: params?.sortDirection || -1,
    sortBy: params?.sortBy || "createdAt",
    search: params?.search ?? "",
  };

  if (params?.skipPagination) payload["skipPagination"] = true;

  let response = await new Client({
    path: "/storeItem/list",
    payload,
  }).post();

  const { items } = response?.data;

  let returnData = {
    message: response.message,
    ...response.data,
    items,
  };

  return returnData;
}

async function getStoreInfo(storeId: any) {
  const resp = await new Client({
    path: "/storeItem/info",
    payload: { storeItemId: storeId },
  }).post();

  return resp;
}

export async function deleteStore(storeId: any) {
  const resp = await new Client({
    path: "storeItem/delete",
    payload: { storeItemId: storeId },
  }).post();

  return resp;
}

export async function updateStoreStatus(storeId: any) {
  const resp = await new Client({
    path: "/storeItem/update/status",
    payload: { storeItemId: storeId },
  }).patch();

  return resp;
}

export { create, update, getStore, getStoreInfo };
